export const dockTypes = {
    en: [
        "Floating dock in current",
        "Tourist dock",
        "Sports dock",
        "Private dock",
        "Floating dock in a sheltered dock from the current",
        "Privately managed tourist dock",
        "Public dock",
        "Hauling slipway",
        "Private tourist dock reserved for members",
        "Floating dock for boats",
        "Commercial tourist port",
        "Floating docks in a Lanca",
        "Floating dock in a protected lanca",
        "Floating dock outside the current channel",
        "Floating dock opposite the current channel",
        "Floating dock in the current channel",
        "Private tourist-sports dock",
        "Regional and private tourist dock, reserved for members",
        "Private dock, reserved for members",
        "Municipal tourist dock",
],
    it: [
            "Pontile galleggiante in corrente",
            "Attracco turistico",
            "Attracco sportivo",
            "Attracco privato",
            "Pontile galleggiante in darsena riparata da corrente",
            "Attracco turistico a gestione privata",
            "Attracco pubblico",
            "Scivolo di alaggio",
            "Attracco turistico privato riservato ai soci",
            "Pontile galleggiante per scafi",
            "Porto turistico commerciale",
            "Pontili galleggianti in Lanca",
            "Pontile galleggiante in lanca protetta",
            "Pontile galleggiante fuori canale di corrente",
            "Pontile galleggiante opposto a canale di corrente",
            "Pontile galleggiante in canale di corrente",
            "Attracco turistico-sportivo privato",
            "Attracco turistico regionale e privato, riservato ai soci",
            "Attracco privato, riservato ai soci",
            "Attracco turistico comunale",
    ]
  };